module.exports = __webpack_public_path__ + "img/44.ca3c420.jpg";